import React, { Fragment, useState, useContext } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Input,
} from "reactstrap";
import { JobSearchContext } from "../../../../JobSearch/JobSearchContext";

const verificationOptions = [
  { value: "all", label: "All" },
  { value: "verified", label: "Verified" },
  { value: "unverified", label: "Unverified" },
];

const VerificationFilter = () => {
  const [isFilter, setIsFilter] = useState(true);
  const { filters, updateFilters } = useContext(JobSearchContext);

  const selectedVerification = filters?.verified_status || "verified";

  const handleRadioChange = (option) => {
    updateFilters({ verified_status: option.value });
  };

  return (
    <Fragment>
      <Col xl="12">
        <Card>
          <CardHeader className="py-3" onClick={() => setIsFilter(!isFilter)} style={{ cursor: "pointer" }}>
            <h5 className="mb-0 p-0">Verification Status</h5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <CardBody className="filter-cards-view animate-chk">
              {verificationOptions.map((option, index) => (
                <label
                  key={index}
                  className="d-flex align-items-center mb-2"
                  htmlFor={`ver-rad-ani-${index}`}
                  style={{ cursor: "pointer" }}
                >
                  <Input
                    className="radio_animated mr-2"
                    id={`ver-rad-ani-${index}`}
                    type="radio"
                    checked={selectedVerification === option.value}
                    onChange={() => handleRadioChange(option)}
                  />
                  <span>{option.label}</span>
                </label>
              ))}
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default VerificationFilter;
